import { CircularProgress } from '@mui/material'
import { initReactQueryAuth } from 'react-query-auth'
import {
  getUser,
  LoginCredentialsDTO,
  loginWithUsernameAndPassword
} from '../services/api/Users'
import { AuthUser, UserResponse } from '../services/api/Users/types'

import storage from '../utils/storage'
import { queryClient } from './react-query'
import { clearAllStores } from '../utils/clearStores'

async function handleUserResponse(data: UserResponse) {
  const { token, ...user } = data
  // O UserResponse tem a estrutura: { token, user: AuthUser, ...AuthUser }
  // O AuthUser está em data.user
  const userId = data?.user?.id || data?.id

  // Verifica se houve mudança de usuário
  const previousUserId = storage.getUserId()
  if (previousUserId && userId && previousUserId !== userId) {
    // Limpa todos os stores quando detecta mudança de usuário
    clearAllStores()
  }

  storage.setToken(token)
  if (userId) {
    storage.setUserId(userId)
  }
  storage.setProductLineId(data?.user?.productLineId)
  return { ...user.user }
}

async function loadUser() {
  if (storage.getToken()) {
    const user: any = await getUser()
    const userId = user?.id || user?.userId

    // Verifica se houve mudança de usuário
    const previousUserId = storage.getUserId()
    if (previousUserId && previousUserId !== userId) {
      // Limpa todos os stores quando detecta mudança de usuário
      clearAllStores()
    }

    storage.setUserId(userId)
    storage.setProductLineId(user?.productLineId)
    return user
  }
  return null
}

async function loginFn(data: LoginCredentialsDTO) {
  // Limpa todos os stores antes de fazer login para evitar dados de usuário anterior
  clearAllStores()
  const response = await loginWithUsernameAndPassword(data)
  const user = await handleUserResponse(response)
  return user
}

async function registerFn() {
  return null
}

async function logoutFn(args?: { redirect?: boolean }) {
  // Limpa todos os stores antes de fazer logout
  clearAllStores()
  storage.clearToken()
  storage.clearUserId()
  // Limpa o cache do React Query para evitar que dados de um usuário sejam reutilizados por outro
  queryClient.clear()
  if (args?.redirect)
    window.location.assign(window.location.origin as unknown as string)
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  ErrorComponent(error: any) {
    if (error?.error?.response?.status === 401) {
      logoutFn({ redirect: true })
      return <div />
    }
    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <span style={{ fontSize: '2rem' }}>
          Falha na conexão com o servidor, tente novamente mais tarde!
        </span>
      </div>
    )
  },
  LoaderComponent() {
    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress size={80} />
      </div>
    )
  }
}

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO,
  undefined
>(authConfig)
